// extracted by mini-css-extract-plugin
export default {"badge":"status-badge_badge__J0nEU","dot":"status-badge_dot__Fn3px"};